import { render, staticRenderFns } from "./ConfirmDivisionHead.vue?vue&type=template&id=12c6df86"
import script from "./ConfirmDivisionHead.vue?vue&type=script&lang=js"
export * from "./ConfirmDivisionHead.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports